import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import sidebarMenuConfig from "./sidebarMenuConfig";

const SidebarMenuItem = ({ item }) => {
  const { t } = useTranslation();
  const { hasAnyPermission } = useAuth();

  // Check permission: no permissions defined = always visible
  if (item.permissions && !hasAnyPermission(item.permissions)) {
    return null;
  }

  // Leaf item (no children)
  if (!item.children) {
    return (
      <li>
        <Link to={item.path} className="waves-effect">
          {item.icon && <i className={item.icon}></i>}
          <span className="ms-1">{t(item.label)}</span>
        </Link>
      </li>
    );
  }

  // Filter children by permission
  const visibleChildren = item.children.filter(
    (child) => !child.permissions || hasAnyPermission(child.permissions),
  );

  if (visibleChildren.length === 0) return null;

  return (
    <li>
      <Link to="/#" className="has-arrow waves-effect">
        {item.icon && <i className={item.icon}></i>}
        <span className="ms-1">{t(item.label)}</span>
      </Link>
      <ul className="sub-menu">
        {visibleChildren.map((child) => (
          <li key={child.path}>
            <Link
              to={child.path}
              className={child.icon ? " waves-effect" : undefined}
            >
              {child.icon && <i className={child.icon}></i>}
              {child.icon ? (
                <span className="ms-1">{t(child.label)}</span>
              ) : (
                t(child.label)
              )}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

const SidebarMenu = () => {
  return (
    <>
      {sidebarMenuConfig.map((item, idx) => (
        <SidebarMenuItem key={item.path || item.label + idx} item={item} />
      ))}
    </>
  );
};

export default SidebarMenu;
